export default {
      id: "seen-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#seen-usage",
      toString: function () {
        return this.url;
      }
    }